import type {
  StammdatenBuergeWorkflowSchema,
  StammdatenUebersichtSchema,
  StammdatenVerwaltenWorkflowSchema,
} from '@/lang/types/mitarbeiter/unternehmen.ts';

export const stammdatenGesellschaftDatenFormular: StammdatenVerwaltenWorkflowSchema = {
  banner: {
    keineAenderungen: {
      text: 'Bitte nehmen Sie mindestens eine Änderung vor, um das Unternehmen speichern zu können oder brechen Sie den Prozess ab.',
    },
    nichtLoeschbar: {
      header: 'Unternehmen kann nicht gelöscht werden',
      text: 'Das Unternehmen ist noch mit bestehenden Daten verknüpft. Bitte entfernen Sie zunächst alle zugehörigen Bürgschaften, Aufträge, Kautionsverträge und Avallinien, bevor Sie das Unternehmen löschen.',
    },
  },
  header: {
    titel: {
      bearbeiten: 'Unternehmen bearbeiten',
      pruefen: 'Unternehmen prüfen',
    },
  },
  sections: {
    header: {
      titel: 'Angaben zum Unternehmen',
      hinweisPruefen: 'Bitte prüfen Sie die Angaben des Unternehmens.',
    },
    firmierung: {
      label: 'Firmierung',
      nameHandelsregister: {
        label: 'Name laut Handelsregister',
        validationName: 'name',
      },
    },
    anschrift: {
      label: 'Anschrift',
    },
    weitereAngaben: {
      label: 'Weitere Angaben',
      gesellschaftsform: {
        label: 'Gesellschaftsform',
        validationName: 'gesellschaftsform',
      },
      handelsregisternummer: {
        label: 'Handelsregisternummer',
        validationName: 'handelsregisternummer',
      },
      handelsregister: {
        label: 'Handelsregister',
        validationName: 'handelsregister',
      },
    },
    aktivitaetsstatus: {
      label: 'Aktivitätsstatus des Unternehmens',
      statusLabel: 'Status',
      textAktiv:
        'Durch Aktivieren ist das Unternehmen berechtigt, digitale Bürgschaften zu erhalten. Nach Deaktivierung kann das Unternehmen keine digitalen Bürgschaften\nmehr erhalten und wird den Bürgen nicht mehr angezeigt.',
      inkognito: {
        label: 'Inkognito',
        iconAlt: 'Inkognito',
        text: 'Im Inkognito-Modus verbleibt das Unternehmen weiterhin aktiv, es kann jedoch\nkeine Bürgschaften als Auftraggeber empfangen.',
      },
    },
  },
  modal: {
    loeschen: {
      buttonText: 'Unternehmen löschen',
      title: 'Löschen bestätigen',
      body: 'Sind Sie sicher, dass Sie dieses Unternehmen löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
      primary: 'Unternehmen löschen',
    },
  },
};

export const stammdatenBuergeDatenFormular: StammdatenBuergeWorkflowSchema = {
  banner: {
    keineAenderungen: {
      text: 'Bitte nehmen Sie mindestens eine Änderung vor, um das Unternehmen speichern zu können oder brechen Sie den Prozess ab.',
    },
  },
  header: {
    titel: {
      erstellen: 'Bürge hinzufügen',
      bearbeiten: 'Unternehmen bearbeiten',
      darstellungBearbeiten: 'Darstellung bearbeiten',
    },
  },
  button: {
    weiter: 'Weiter',
  },
  sections: {
    angaben: {
      header: {
        titel: 'Angaben zum Bürgen',
      },
      firmierung: {
        label: 'Firmierung',
        nameHandelsregister: {
          label: 'Name laut Handelsregister',
          validationName: 'name',
        },
      },
      anschrift: {
        label: 'Anschrift',
      },
      weitereAngaben: {
        label: 'Weitere Angaben',
        gesellschaftsform: {
          label: 'Gesellschaftsform',
          validationName: 'gesellschaftsform',
        },
        handelsregisternummer: {
          label: 'Handelsregisternummer',
          validationName: 'handelsregisternummer',
        },
        handelsregister: {
          label: 'Handelsregister',
          validationName: 'handelsregister',
        },
      },
      vertretungsberechtigter: {
        label: 'Vertretungsberechtigte:r',
        vorname: {
          label: 'Vorname',
          validationName: 'person.vorname',
        },
        nachname: {
          label: 'Nachname',
          validationName: 'person.nachname',
        },
        telefonnummer: {
          validationName: 'person.telefonnummer',
        },
        email: {
          label: 'E-Mail-Adresse',
          validationName: 'person.email',
        },
      },
    },
    einstellungen: {
      label: 'Einstellungen des Unternehmens',
      vertragspartner: {
        label: 'Vertragspartner von Trustlog',
        text: 'Wenn der Bürge die vertragliche Zusage zur Teilnahme an Trustlog gegeben hat, kann er hierüber als Vertragspartner von Trustlog aktiviert werden. Somit wird er zum vollwertigen Bürgen, der über Trustlog digitale Bürgschaften ausstellt.',
        hinweis: 'Diese Einstellung ist nicht umkehrbar.',
      },
    },
    anzeigedaten: {
      header: {
        titel: 'Darstellung des Bürgen',
      },
      banner: {
        keineAenderungen: {
          text: 'Bitte nehmen Sie mindestens eine Änderung vor, um die Darstellung zum Unternehmen speichern zu können oder brechen Sie den Prozess ab.',
        },
      },
      initialen: {
        label: 'Initialen',
        input: {
          label: 'Initialen',
        },
      },
      kurzname: {
        label: 'Kurzname',
        input: {
          label: 'Kurzname',
        },
      },
      hintergrund: {
        label: 'Hintergrund',
        input: {
          label: 'Hintergrundfarbe in HEX',
        },
      },
      schriftfarbe: {
        label: 'Schriftfarbe des Unternehmens',
        automatisch: 'automatisch',
        manuell: 'manuell',
        input: {
          label: 'Schriftfarbe in HEX',
        },
      },
    },
  },
};

export const stammdatenUebersicht: StammdatenUebersichtSchema = {
  banner: {
    geloescht: {
      text: 'Das Unternehmen wurde erfolgreich gelöscht.',
    },
  },
  unternehmensId: 'Unternehmens-ID',
  dropdown: {
    stammdatenBearbeiten: 'Stammdaten bearbeiten',
    darstellungBearbeiten: 'Darstellung bearbeiten',
    gevosBearbeiten: 'Geschäftsvorfälle bearbeiten',
    preismodellBearbeiten: 'Preismodell bearbeiten',
  },
  stammdaten: {
    titel: 'Stammdaten',
    name: 'Name des Unternehmens',
    anschrift: 'Anschrift',
    gesellschaftsform: 'Gesellschaftsform',
    handelsregisternummer: 'Handelsregisternummer',
    handelsregister: 'Handelsregister',
    vertretungsberechtigter: 'Vertretungsberechtigte:r',
  },
  tabs: {
    unternehmen: 'Unternehmen',
    nutzer: 'Nutzer',
    vertraege: 'Verträge',
    eingegangeneBuergschaften: 'Eingegangene Bürgschaften',
    ausgestellteBuergschaften: 'Ausgestellte Bürgschaften',
  },
};
